import React, { Component } from "react";
import { connect } from "react-redux";

class ThemeExperiment extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isBlackTextEnabled:
				document.body.classList.contains("black-main-text"),
		};
	}

	toggleBlackText = () => {
		if (document.body.classList.contains("black-main-text")) {
			document.body.classList.remove("black-main-text");
			this.setState({ isBlackTextEnabled: false });
		} else {
			document.body.classList.add("black-main-text");
			this.setState({ isBlackTextEnabled: true });
		}
	};

	render() {
		return (
			<div style={{ paddingTop: 20, paddingLeft: 15 }}>
				<h3 style={{ fontSize: 20 }}>Theme Experiment</h3>
				<button
					onClick={this.toggleBlackText}
					style={{ padding: "10px 20px", fontSize: "1em" }}
				>
					{this.state.isBlackTextEnabled
						? "Disable Black Main Text"
						: "Enable Black Main Text"}
				</button>
				<div style={{ marginTop: 32, width: 300 }}>
					This will just change the theme temporarily in your browser
					only, not for any other users. The theme will not persist
					after refreshing.
				</div>
			</div>
		);
	}
}

export default connect(null, {})(ThemeExperiment);
